import { DropdownMenu } from '@dittolive/anvil'
import graphql from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import paths from 'paths'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'
import { useNavigate } from 'react-router-dom'

import { OrganizationAppsMenuItem_viewer$key } from './__generated__/OrganizationAppsMenuItem_viewer.graphql'
import { OrganizationAppsMenuItemQuery } from './__generated__/OrganizationAppsMenuItemQuery.graphql'
import { ViewerAppsRefetchQuery } from './__generated__/ViewerAppsRefetchQuery.graphql'

const query = graphql`
  query OrganizationAppsMenuItemQuery($slug: String!) {
    viewer {
      ...OrganizationAppsMenuItem_viewer
    }
  }
`

const refetchableApps = graphql`
  fragment OrganizationAppsMenuItem_viewer on Viewer
  @refetchable(queryName: "ViewerOrganizationAppsRefetchQuery") {
    organization(slug: $slug) {
      # eslint-disable-next-line relay/unused-fields
      id
      apps {
        # eslint-disable-next-line relay/unused-fields
        id
        name
        slug
      }
    }
  }
`

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
  slug: string
}

export default function OrganizationAppsMenuItem({ isOpen, slug }: Props) {
  const { viewer } = useLazyLoadQuery<OrganizationAppsMenuItemQuery>(query, {
    slug,
  })
  const [data, refetch] = useRefetchableFragment<
    ViewerAppsRefetchQuery,
    OrganizationAppsMenuItem_viewer$key
  >(refetchableApps, viewer)

  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
  }, [refetch, isOpen])

  const apps = data?.organization?.apps ?? []

  const { databasesText, isRenamed } = useAppToDatabaseRename()

  return (
    <>
      {apps.length > 0 ? (
        apps.map((orgApp, index) => {
          const redirectTo = paths.app({
            organizationSlug: slug,
            appSlug: orgApp.slug,
            isRenamed,
          })

          return (
            <DropdownMenu.Item
              key={index}
              onSelect={() => navigate(redirectTo)}
            >
              {orgApp.name}
            </DropdownMenu.Item>
          )
        })
      ) : (
        <DropdownMenu.Item disabled>
          No organization {databasesText} found
        </DropdownMenu.Item>
      )}
    </>
  )
}
